import React from "react";
import Services from "../components/Services";
import Blogs from "../components/Blogs";

export default function Home() {
  return (
    <div>
      
      <Services />
      <Blogs/>
    </div>
  );
}